module.exports = __webpack_public_path__ + "static/media/woman.b1e4886e.jpg";